import { createFileRoute } from '@tanstack/react-router'
import ImportsSettings from '@/pages/settings/imports'
export const Route = createFileRoute('/(protected)/workspaces/$workspaceId/settings/imports')({
  validateSearch: (search: Record<string, unknown>) => ({ run: typeof search.run === 'string' ? search.run : undefined }),
  component: ImportsSettings,
})
